import {
    MetricsService,
    UserAction,
    userActionTypeEnum,
} from '@thoughtspot/metrics';
import { get1MindBotExcludedPaths } from '@thoughtspot/session-service';

export const ONE_MIND_SOURCE = {
    BANNER: 'Banner',
    WIDGET: 'Widget',
};

export const collectOneMindBotMetrics = (
    metricsService: MetricsService,
    userActionType: typeof userActionTypeEnum[keyof typeof userActionTypeEnum],
    source: string,
) => {
    metricsService.collectEvent(new UserAction(userActionType), {
        source,
    });
};

export const hideOneMindBot = (currentPath: string, hideBot = false) => {
    const excludedPaths = get1MindBotExcludedPaths();
    const shouldHideOneMindBot = excludedPaths.some(path =>
        currentPath.startsWith(path),
    );
    const iframeParentDiv = document.querySelector(
        '[id="onemind-widget"]',
    ) as HTMLElement;
    if (iframeParentDiv) {
        iframeParentDiv.style.display =
            hideBot || shouldHideOneMindBot ? 'none' : '';
    }
};

export const ONE_MIND_URL = 'https://thoughtspot-websitebdr-sandbox.1mind.com';
